/** Each private audio replacement has an immutable upload directory. Keep its
 * published assets in a matching revision so existing listeners keep their audio
 * until the replacement is ready, and CDN caches cannot serve the old bytes. */
export function privateAudioRevision(sourcePath: string | null): string | null {
  return (
    sourcePath?.match(
      /^gs:\/\/lissencatalog-exclusive-songs-landing\/private-song-originals\/edits\/([a-f0-9-]{36})\/[^/]+$/,
    )?.[1] ?? null
  );
}
export function privateAudioRevisionPrefix(
  revision: string,
  environmentPrefix = "",
) {
  return `${environmentPrefix}private-audio/${revision}/`;
}
